export default __webpack_public_path__ + "5928c141ce773cb94fe6a573f473aa79.wav";